import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = {
        anchor: String
    }

    connect() {
        if (!this.shouldActivate()) return

        requestAnimationFrame(() => {
            this.scrollIntoView()
            this.highlight()
        })
    }

    shouldActivate() {
        return window.location.hash === `#${this.anchorValue}`
    }

    scrollIntoView() {
        const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches

        this.element.scrollIntoView({
            behavior: prefersReducedMotion ? "auto" : "smooth",
            block: "start"
        })
    }

    highlight() {
        this.element.classList.add("activation-kit-highlight")

        window.setTimeout(() => {
            this.element.classList.add("activation-kit-highlight-fade")
        }, 1200)

        window.setTimeout(() => {
            this.element.classList.remove("activation-kit-highlight")
            this.element.classList.remove("activation-kit-highlight-fade")
        }, 2200)
    }
}
